<button
	[id]="id"
	class="flex gap-1 bg-white items-center text-sm rounded-md text-grey-dark py-1 px-2"
	(mouseover)="mouseoverButton()"
	(mouseout)="mouseoutButton()"
	attr.data-intercom-target="{{ intercomTarget }}"
	[testHook]="testHook"
>
	<i-tabler *ngIf="icon" [name]="icon" class="w-4 h-4"></i-tabler>
	<span class="font-medium text-sm hidden xl:inline-block">{{ title }}</span>
	<span class="w-10" *ngIf="showPercentage">({{ num }}%)</span>
	<span class="w-10" *ngIf="!showPercentage">({{ num }})</span>
	<app-icon [icon]="showDropdown ? ICON.UP : ICON.DOWN"></app-icon>
</button>

<div class="flex relative">
	<div
		*ngIf="showDropdown"
		(mouseover)="mouseoverDropdown()"
		(mouseout)="mouseoutDropdown()"
	>
		<ng-content></ng-content>
	</div>
</div>
